var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-rundown"},[_c('div',{directives:[{name:"track",rawName:"v-track",value:([
      {
        act: 'show',
        params: {
          cfrom: '081|063|02|077',
          event_id: '081|063|02|077',
          goodtype: _vm.goodsType,
          goodid: _vm.skuId,
          module: 2,
          pagetype: 0
        }
      },
      {
        act: 'click',
        params: {
          cfrom: '081|063|01|077',
          event_id: '081|063|01|077',
          goodtype: _vm.goodsType,
          goodid: _vm.skuId,
          module: 2,
          pagetype: 0
        }
      }
    ]),expression:"[\n      {\n        act: 'show',\n        params: {\n          cfrom: '081|063|02|077',\n          event_id: '081|063|02|077',\n          goodtype: goodsType,\n          goodid: skuId,\n          module: 2,\n          pagetype: 0\n        }\n      },\n      {\n        act: 'click',\n        params: {\n          cfrom: '081|063|01|077',\n          event_id: '081|063|01|077',\n          goodtype: goodsType,\n          goodid: skuId,\n          module: 2,\n          pagetype: 0\n        }\n      }\n    ]"}],staticClass:"container",attrs:{"tabindex":"0"},on:{"click":_vm.showGroup}},[_c('div',{staticClass:"leftrun"},[_c('div',{staticClass:"title"},[_vm._v("玩法")]),_c('div',{staticClass:"run"},[(_vm.isDark)?_c('img',{attrs:{"src":require("../imgs/one-group-dark.png"),"alt":"1、开团/参团，2、邀请好友，3、成团抽奖，4、中奖发货"}}):_c('img',{attrs:{"src":require("../imgs/one-group.png"),"alt":"1、开团/参团，2、邀请好友，3、成团抽奖，4、中奖发货"}})])]),_c('div',{staticClass:"icon-ask"})]),_c('v-os-popup',{attrs:{"container":"body","title":"拼团玩法","footerShow":false},on:{"close":function($event){_vm.showPop = false}},model:{value:(_vm.showPop),callback:function ($$v) {_vm.showPop=$$v},expression:"showPop"}},[_c('div',{staticClass:"groupon-rule-pop",domProps:{"innerHTML":_vm._s(_vm.grouponRuleInfo)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }